import axios from "axios";

const API_URL = process.env.REACT_APP_API;

export const search = async (data) => {
  try {
    // console.log("Fetching from analysis...", data)
    // Timer start
    const start = performance.now()

    // La request
    const response = await axios.post(
      `/api/analisis/estatico/search/`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    // Timer end y log
    const end = performance.now();
    const duration = (end - start).toFixed(2);
    // console.log(`Request took ${duration} ms`, response.data);


    return response.data.datos;

  } catch (error) {
    console.error("API Request Error:", error);
    throw error;
  }
};

export const searchApk = async (data) => {
  try {
    // console.log("Fetching from apk...", data)
    // Timer start
    const start = performance.now()

    // La request
    const response = await axios.post(
      `/api/apks/search/`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    // Timer end y log
    const end = performance.now();
    const duration = (end - start).toFixed(2);
    // console.log(`Request took ${duration} ms`, response.data);
    console.log(``)

    return response.data.datos;

  } catch (error) {
    console.error("API Request Error:", error);
    throw error;
  }
};